import React from 'react';
import { formStyles } from '../../constants/SiteVariables';
import { MaskedField } from './MaskedField';

export default function ColumnInput({
  children,
  error
}) {
  const multi = Array.isArray(children);
  const columnClass = 'column';

  return (
    <div className={formStyles.input(error)}>
      {multi ?
        children
          .map((c, key) => <div key={key} className={c.props.className ? columnClass + ' ' + c.props.className : columnClass}>
            {c.props.error ? c : React.cloneElement(c, { error })}
          </div>) :
        <div className={children?.props?.className ? columnClass + ' ' + children?.props.className : "column"}>{React.cloneElement(children, { error })}</div>}
    </div>
  );
}
